import React, { useEffect } from 'react';

export default function Lightbox({ images, currentIndex, onClose, onPrev, onNext }) {
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') onClose();
      if (e.key === 'ArrowLeft') onPrev();
      if (e.key === 'ArrowRight') onNext();
    };
    window.addEventListener('keydown', handleKeyDown);
    document.body.style.overflow = 'hidden';

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
      document.body.style.overflow = 'unset';
    };
  }, [onClose, onPrev, onNext]);

  if (!images || images.length === 0) return null;

  const currentImage = images[currentIndex];

  return (
    <div className="fixed inset-0 z-50 bg-black/95 flex flex-col justify-between p-4 md:p-8 animate-fade-in">
      {/* Header with counter and close button */}
      <div className="flex items-center justify-between text-white/80 text-sm tracking-widest">
        <span>
          {currentIndex + 1} / {images.length}
        </span>
        <button
          onClick={onClose}
          className="p-2 text-white hover:text-white/70 transition-colors duration-300 focus:outline-none"
          aria-label="Luk"
        >
          <i className="fa-solid fa-xmark text-2xl" />
        </button>
      </div>

      {/* Main Image Area */}
      <div className="relative flex-1 flex items-center justify-center max-h-[80vh] my-4">
        {/* Prev Button */}
        {images.length > 1 && (
          <button
            onClick={onPrev}
            className="absolute left-2 md:left-6 z-10 p-3 text-white/70 hover:text-white transition-colors duration-300 focus:outline-none bg-black/30 hover:bg-black/50 rounded-full"
            aria-label="Forrige billede"
          >
            <i className="fa-solid fa-chevron-left text-xl md:text-2xl" />
          </button>
        )}

        {/* Image */}
        <img
          src={currentImage}
          alt={`Galleri visning ${currentIndex + 1}`}
          className="max-w-full max-h-full object-contain rounded-sm select-none animate-zoom-in"
          draggable={false}
        />

        {/* Next Button */}
        {images.length > 1 && (
          <button
            onClick={onNext}
            className="absolute right-2 md:right-6 z-10 p-3 text-white/70 hover:text-white transition-colors duration-300 focus:outline-none bg-black/30 hover:bg-black/50 rounded-full"
            aria-label="Næste billede"
          >
            <i className="fa-solid fa-chevron-right text-xl md:text-2xl" />
          </button>
        )}
      </div>

      {/* Footer / Instructions */}
      <div className="text-center text-white/40 text-[11px] tracking-[0.2em] uppercase pb-2">
        Brug piletasterne eller klik på pilene for at navigere
      </div>
    </div>
  );
}
